



























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Tag extends Vue {
  @Prop({ type: String, required: true }) tagText!: string
  @Prop({ type: Number, required: false }) tagId!: string | number | undefined
  @Prop({ type: Boolean, default: false }) removable!: boolean
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  @Prop({ type: Boolean, default: false }) error!: boolean

  onXClicked() {
    if (!this.removable || this.disabled) {
      return
    }
    this.$emit('x-pressed', this.tagText)
  }
}
